<template>
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        @click="dialog = true"
        color="accent"
      >
        <v-icon class="mr-1" small>mdi-pencil</v-icon>
        Editar Nome e Setores
      </v-btn>
    </template>


    <v-card>
      <v-card-title class="docgo white--text title" primary-title>
        <v-icon
          color="white"
          class="pr-4"
        >mdi-file-document-box-plus
        </v-icon>
        <span >Novo Modelo de Despacho</span>
      </v-card-title>
      <v-card-text>

        <v-form
          v-model="valid"
          ref="form"
        >

          <v-text-field label="Nome do Modelo do Despacho"
                        v-model="title"
                        :rules="[v => !!v || 'Nome é Obrigatório']"
                        :counter="80"
                        required/>


          <v-autocomplete
            v-model="administrativeUnits"
            :items="administrativeUnitsAvailable"
            item-text="name"
            item-value="id"
            return-object
            no-data-text="Nenhum setor encontrado"
            :rules="[v => !!v || 'Setor é Obrigatório']"
            label="Setores"
            multiple
            required
          >
            <v-list-tile
              slot="prepend-item"
              ripple
              @click="toogleSelection()"
            >
              <v-list-tile-action>
                <v-icon>{{ toogleSelectOrRemoveAll ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{toogleSelectOrRemoveAll ? 'Remover' : 'Selecionar'}} Todos</v-list-tile-title>
            </v-list-tile>
            <v-divider
              slot="prepend-item"
              class="mt-2"
            />
          </v-autocomplete>

        </v-form>
      </v-card-text>
      <v-card-actions class="justify-space-between">
        <v-btn flat
               @click="dialog = false"
               :disabled="!valid">Cancelar
        </v-btn>
        <v-btn color="blue darken-1 white--text"
               :disabled="!valid"
               @click="saveChanges()"
        >Continuar
        </v-btn>
      </v-card-actions>
    </v-card>


  </v-dialog>
</template>

<script>
  export default {
    name: 'EditAttributesDispatchDialog',
    props: ['dispatch', 'administrativeUnitsAvailable'],
    data() {
      return {
        title: '',
        administrativeUnits: [],
        dialog: true,
        valid: false,
        toogleSelectOrRemoveAll: false
      };
    },
    methods: {
      saveChanges() {
        this.$emit('save', {
          title: this.title,
          administrativeUnits: this.administrativeUnits
        });
        this.dialog = false
      },
      reloadParams() {
        this.title = this.dispatch.title;
        this.administrativeUnits = this.dispatch.administrativeUnits;
        this.toogleSelectOrRemoveAll = this.administrativeUnits.length === this.administrativeUnitsAvailable.length
      },
      toogleSelection() {
        this.toogleSelectOrRemoveAll = !this.toogleSelectOrRemoveAll;
        if (this.toogleSelectOrRemoveAll) {
          this.administrativeUnits = this.administrativeUnitsAvailable;
        } else {
          this.administrativeUnits = [];
        }

      }
    },
    watch: {
      dialog(newValue) {
        if (newValue) {
          this.reloadParams();
        }
      },
      dispatch(newValue) {
        this.reloadParams();
      },
      administrativeUnits(newValue) {
        if (newValue.length < this.administrativeUnitsAvailable.length) {
          this.toogleSelectOrRemoveAll = false
        }
      }
    }
  }
  ;
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/settings/dispatches/EditAttributesDispatchDialog.vue